export default "__VITE_PUBLIC_ASSET__2d96126f__"